import { HStack, Separator, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { formatLongDate } from '@/lib/format-long-date';

interface ConversationDayDividerProps {
  /** The day a group of the thread falls on, as the feed groups it. */
  date: string;
}

/** The day line between two days of a conversation thread, in the UI language. */
const ConversationDayDivider = ({ date }: ConversationDayDividerProps) => {
  const { i18n } = useTranslation();

  return (
    <HStack my={6} gap={4}>
      <Separator flex="1" />
      <Text fontSize="xs" fontWeight="medium" color="gray.500">
        {formatLongDate(date, i18n?.language ?? 'en')}
      </Text>
      <Separator flex="1" />
    </HStack>
  );
};

export default ConversationDayDivider;
